/**
 * Single source of truth for identifying an HTTP request bound for wallet-pass-service.
 * Both wallet interceptors (mock preview, language header) key off this instead of each
 * hardcoding their own copy of the path segment, so a backend route change only needs
 * updating here.
 */
export const WALLET_PASS_SERVICE_PATH = "wallet-pass-service";

export const WALLET_DESIGN_PREVIEW_PATH = "design-config/preview";

export const isWalletPassServiceRequest = (url: string): boolean => url.includes(WALLET_PASS_SERVICE_PATH);

export const isWalletDesignPreviewRequest = (url: string): boolean => url.includes(WALLET_DESIGN_PREVIEW_PATH);
